
import axios from "axios";

const BASE_URL = "https://api.hsforms.com/submissions/v3/integration/submit"; //"https://api.hsforms.com/submissions/v3/integration/submit/:portalId/:formGuid"

export default class FormApi {
  request = null;
  maasRequest = null;
  constructor() {
    this.request = axios.create({
      baseURL: BASE_URL, maxContentLength: 100000000,
      maxBodyLength: 1000000000, headers: { }
    });
  }
  
  requestOptions = ({ path, params, data, headers }) => {
    const fullHeaders = { ...headers };
    const ret = {
      headers: fullHeaders,
      json: true,
      baseURL: BASE_URL,
      url: path,
      responseType: 'json',
    };
    if (params) {
      ret['params'] = params;
    }
    if (data) {
      ret['data'] = data;
    }
    return ret;
  };

 
  post = (path, params, data, headers, onOptions) => {
    let options = this.requestOptions({ path, params, data, headers });
    options.method = "POST";
    if (onOptions) {
      options = onOptions(options);
    }
    return axios(options);
  };

  getCancelToken = () => {
    return axios.CancelToken.source();
  }

};